import moment from 'moment'

function date (unix) {
  if (typeof (unix) !== 'number') return unix
  return moment(unix).format('M/D/YYYY')
}

export default date
